export const enum SPIN_STYLES {
    ONLY_BLUR = 'onlyBlur',
    BLUR_WITH_SPIN = 'blurWithSpin',
    BLUR_WITH_LINE = 'blurWithLine',
    BLUR_WITH_SPIN_LINE = 'blurWithSpinLine',
    SPIN = 'spin',
    LINE = 'line'
}

export const enum SPIN_TYPES {
    OVERLAY = 'overlay',
    SKELETON = 'skeleton'
}

export const enum SPIN_POSITION {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right'
}

export const enum SPIN_APPEND {
    BODY = 'body',
    HOST = 'host',
    PARENT = 'parent'
}

export class SpinInputModel {
    width: string = '100%'; // Default skeleton width
    isSpinShown: boolean; // Default spinner visibility
    type: SPIN_TYPES = SPIN_TYPES.OVERLAY; // Default spinner type
    data?: any = null; // Default data
    top: string = '5px'; // Default top position
    spinPosition: SPIN_POSITION = SPIN_POSITION.RIGHT; // Default spinner position
    appendTo: SPIN_APPEND; // Append target
    spinnerStyles: SPIN_STYLES; // Spinner styles
    delay: number = 100; // Delay before showing spinner

    constructor(
        appendTo: SPIN_APPEND = SPIN_APPEND.HOST,
        spinnerStyles: SPIN_STYLES = SPIN_STYLES.SPIN,
        isSpinShown: boolean = false
    ) {
        this.appendTo = appendTo ? appendTo : SPIN_APPEND.HOST;
        this.spinnerStyles = spinnerStyles ? spinnerStyles : SPIN_STYLES.SPIN;
        this.isSpinShown = isSpinShown;
    }
}